import React, { useState } from 'react'
import styled from 'styled-components'
import { NewDatabase } from './CreateDatabase/NewDatabase'

const Text = styled.p`
    z-index: 11;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 20px;
    width: 100%;
    text-align: center;
    color: #364159;
`

interface Props {
    upload: Function
    history: Function
    remove?: Function
    isModel?: boolean
    model?: string
    updateModels: any
}

const Button = styled.button`
    width: 200px;
    margin-right: 10px;
    color: var(--gray-0);
    background-color: #37a3ef;
    border: none;
    padding: 8px 0;
    border-radius: 3px;
    span {
        font-family: Source Sans Pro, Open Sans Pro, Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 15px;
        line-height: 16px;
        margin-left: 6px;
        color: var(--gray-0);
    }
 &:hover{
    color: var(--gray-0);
    background-color: #128ce1;
    border-color: #00608a;
 }
`

export default function UploadButton({ upload, history, remove, isModel, model, updateModels }: Props) {
    //@ts-ignore
    const hasPermissions = window.Live.authorization.permissions['CREATE_SPREADSHEET'] !== undefined

    if (!hasPermissions) {
        return null
    }
    const [showModal, setStateModal] = useState<boolean>(false)

    return (
        <div>
            <NewDatabase
                show={showModal}
                onHide={() => setStateModal(false)}
                history={history}
                updateModels={updateModels}
            />
            <Button onClick={() => setStateModal(true)}>
                <i className="fas fa-plus" />
                <span>Add Database</span>
            </Button>
        </div>
    )
}
